// REACT //
import { useCallback, useEffect, useRef, useState } from "react";
// AG GRID MODULE //
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
// ICONS //
import HandymanIcon from "@mui/icons-material/Handyman";
// MUI //
import { Box, Button, TextField } from "@mui/material";
// FILES PROJECT //
import FormTitle from "../../components/helpers/FormTitle";
import { RequestHelper } from "../../utils/requestHelper";
import { getDataGeneric } from "../../repository/DataGeneric";
import { _ROUTES } from "../../utils/_routes_constants";
import BasicModal from "../../components/helpers/BasicModal";
import AppRights from "../../services/AppRights";
import { _ROLES_BACK } from "../../utils/constants";
import FormVolumeFilaire from "../../components/administation/volume-filaire/FormVolumeFilaire";
import ColumnBuilder from "../../components/administation/volume-filaire/CoumnBuilder";
import { DataTable } from "../../components/ui/DataTable";

ModuleRegistry.registerModules([AllCommunityModule]);

const requestHelper = new RequestHelper();

export default function VolumeFilaireAdmin() {
  const [rows, setRows] = useState([]);
  const [rowData, setRowData] = useState([]); // row in edit mode
  const [isEdit, setIsEdit] = useState(false); // true = edit mode
  const [showModal, setShowModal] = useState(false);
  const ref = useRef();

  // context : 'create' | 'edit'
  const onModalOpen = (context) => {
    setShowModal(true);
    setIsEdit(context === "edit");
  };

  const cols = ColumnBuilder(setRows, setRowData, onModalOpen);

  const onFilterTextBoxChanged = useCallback(() => {
    ref.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-volume-filaire").value,
    );
  }, []);

  useEffect(() => {
    if (rows.length === 0) {
      getDataGeneric(
        requestHelper,
        {},
        (d) => {
          if (d.length > 0) {
            setRows(d);
          }
        },
        _ROUTES.VOLUME_FILAIRE,
        "Unable to retrieve any volume filaire",
      );
    }
  }, []);

  return (
    <>
      <AppRights
        roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CONTROLE_GESTION]}
      />
      <FormTitle title="Volumes filaire" />
      {/* MODAL */}
      <BasicModal
        showModal={showModal}
        setShowModal={setShowModal}
        title={"Volume Filaire"}
        content={
          <FormVolumeFilaire
            setRows={setRows}
            isEdit={isEdit}
            rowData={rowData}
          />
        }
        icon={<HandymanIcon />}
        width={"500"}
      />
      {/* FILTER */}
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}
      >
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <TextField
              label="Find"
              variant="outlined"
              size="small"
              name="volumeFilaire"
              id="filter-volume-filaire"
              onInput={onFilterTextBoxChanged}
            />
          </Box>
          <Box>
            <Button
              variant="contained"
              size="small"
              title={"New User"}
              startIcon={<HandymanIcon />}
              color="success"
              onClick={() => {
                onModalOpen("create");
              }}
            >
              {"New Volume Filaire"}
            </Button>
          </Box>
        </Box>
      </Box>
      {/* AG-GRID */}
      <DataTable
        rows={rows}
        columns={cols}
        height={450}
        rowHeight={30}
        fullHeight={false}
        showExport={false}
        showFullScreen={true}
        agGridProps={{}}
        onCellValueChanged={null}
        excelStyles={null}
      />
    </>
  );
}
